import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { useAuth } from '../context/AuthContext'

// QUÉ PARTE DEL PANEL DE PLATAFORMA PUEDE VER ESTA PERSONA.
//
// Una sola llamada (`GET /api/superadmin/mis-secciones`) que trae TRES cosas: las secciones
// concedidas, el catálogo entero (con el nombre en cristiano de cada una y su categoría) y el orden
// de las categorías. El catálogo viene entero también para quien tiene acceso parcial: el menú
// necesita el nombre y el grupo de cada sección para ordenarse, y recortarlo obligaría a una segunda
// petición solo para pintar un título.
//
// SE PREGUNTA SOLO SI LA PERSONA ES DE PLATAFORMA. Esa ruta responde 403 a quien no lo es —y hace
// bien—, así que llamarla desde la aplicación normal solo serviría para llenar la consola de errores
// a todo el mundo. `es_superadmin` ya viaja en el login.
//
// Y MIENTRAS CARGA NO SE DECIDE NADA: `listo` es false hasta que la respuesta está. Pintar el menú
// con `secciones: []` a medio cargar haría parpadear el panel entero y, peor, echaría de su propia
// pantalla a quien acaba de recargar con F5.
export function useSeccionesPlataforma() {
  const { user } = useAuth()
  const esPlataforma = user?.es_superadmin === true
  const { data, isLoading, error } = useQuery({
    queryKey: ['plataforma-mis-secciones'],
    queryFn: () => api.get('/superadmin/mis-secciones').then(r => r.data),
    enabled: esPlataforma,
    staleTime: 60000,
    retry: false,
  })
  return {
    esPlataforma,
    // `listo` = ya se sabe la respuesta. Si la persona no es de plataforma no hay nada que esperar.
    listo: !esPlataforma || (!isLoading && (!!data || !!error)),
    // Si la petición falla (servidor viejo sin esa ruta, red caída) NO se abre el panel entero por
    // las bravas: se queda sin secciones y el servidor sigue siendo quien decide en cada llamada.
    secciones: data?.secciones || [],
    catalogo: data?.catalogo || [],
    categorias: data?.categorias || [],
    pleno: data?.pleno === true,
    // SI EL PANEL ESTA EN MODO AVERIA LO DICE EL SERVIDOR, no lo deduce esta linea comparando
    // `motivo` con la lista de averias que habia el dia que se escribio. El `||` de detras es para
    // un servidor viejo que todavia no manda el campo: nunca se abre por no saberlo.
    degradado: data?.degradado === true
      || data?.motivo === 'sin_migrar' || data?.motivo === 'sin_pleno_degradado',
    // LA CAPACIDAD DE LA AVERIA: «puedes MIRAR el panel para diagnosticar». Durante una averia el
    // servidor NO concede ninguna seccion (una seccion autoriza en toda la aplicacion, y por ahi se
    // escapo tres veces: el PVP de los mensajes de WhatsApp y el soporte de otra clinica escribian
    // con ellas), asi que `secciones` viene VACIA y sin este campo el menu se quedaria en blanco —
    // que es el problema que la degradacion existe para evitar. Nunca se abre por no saberlo: si el
    // servidor no manda el campo, es false.
    lecturaPanel: data?.lectura_panel === true,
    motivo: data?.motivo || null,
    error: error || null,
  }
}
